var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-carousel"},[_c('VueSlickCarousel',{key:`carousel-${_vm.productImages.length}`,attrs:{"dots":true,"settings":_vm.slickOptions}},_vm._l((_vm.productImages),function(image){return _c('div',{key:image},[_c('img',{attrs:{"src":image,"alt":"Ring"}})])}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }